<template>

        <div class="main-report tbl-list report-detail">
          <span class="report-name">
            <label class="required mr-3">会議名</label>
            <input type="text" id="agendaname" v-model="agendaName" v-bind:disabled=true class="minutes-mode-readonly form-control text-meeting" placeholder="会議名を入力" autocomplete="off" style="text-align: left;" onchange="activeMakeReportBtn()">
          </span>
          <span>
            <span class="title-detail title-margin" style="display: flex;justify-content: end;visibility:hidden;">
              <label>【アジェンダ】</label>
              <span id="agenda_state_head"></span>
            </span>
            <span class="title-detail title-margin" >
              <label>【議　事　録】</label>
              <span id="minutes_state_head">{{ minutes_state_name }}</span>
            </span>
          </span>
        </div>
        
        <div class="basic_info_area">
          <h4>
            <span class="icon icon-up"  v-b-toggle="'basic_info_toggle'" role="button"  id="basic_info_toggle-target" ></span>基本情報
          </h4>
          <b-collapse id="basic_info_toggle">
          <div class="collapse show content-box" id="basic_info">
            <table class="agenda_info_table">
              <tbody>
                <tr>
                  <td class="td-icon">
                    <img class="mr-2" src="~@/assets/img/meeting-icon-grey.png" width="25" height="25" alt="">
                  </td>
                  <td class="td-label">
                    <label class="pl-2 pr-2">会議体</label>
                  </td>
                  <td class="td-info">
                    <span class="" id="committee">{{committeeName}}</span>
                    <input type="hidden" name="" id="committeeID" class="form-control" readonly="true" style="width: max-content;">
                  </td>
                </tr>
                <tr>
                  <td class="td-icon">
                    <img class="mr-2" src="~@/assets/img/format.png" width="25" height="25" alt="">
                  </td>
                  <td class="td-label">
                    <label class="pl-2 pr-2">報告書フォーマット</label>
                  </td>
                  <td class="td-info">
                    <span class="select-wrap"  style="width:30%;">
                      <select name="format_id" id="selectFormat" class="form-control select-format editable-select minutes-mode-readonly" modallabel="報告書フォーマット" v-model="formatName" v-bind:disabled=true>
                      <option>{{formatName}}</option>
                      </select>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="td-icon">
                    <img class="mr-2" src="~@/assets/img/clock.png" width="25" height="25" alt="">
                  </td>   
                  <td class="td-label">
                    <label class="pl-2 pr-2 required">開催日時</label>
                  </td>
                  <td class="td-info" style="display:flex;">
                    <span>
                      <div class="input-group input-icon-calendar" style="width:9vw;">
                        <input type="text" id="meetDate" v-model="meetingDate" v-bind:disabled=true class="minutes-mode-readonly form-control input-date" autocomplete="off" style="padding: 3px 0 3px 2em;" onchange="activeMakeReportBtn();setDeptCombo()">
                      </div>
                    </span>
                    <span class="input-time ml-3" id="mtime">
                      <input type="text" v-model="timeFrom" v-bind:disabled=true class="form-control datetimepicker-input minutes-mode-readonly" id="meetStartTime" autocomplete="off" data-toggle="datetimepicker" data-target="#meetStartTime" onchange="activeMakeReportBtn()" placeholder="__:__"/>
                      &nbsp;～&nbsp;
                      <input type="text" v-model="timeTo" v-bind:disabled=true class="form-control datetimepicker-input minutes-mode-readonly" id="meetFinishTime" autocomplete="off" data-toggle="datetimepicker" data-target="#meetFinishTime" placeholder="__:__"/>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="td-icon" style="vertical-align: middle;">
                    <img class="mr-2" src="~@/assets/img/pin2.png" width="25" height="25" alt="">
                   </td>   
                   <td class="td-label">
                    <label class="pl-2 pr-2 place_url_label">場所</label>
                  </td>
                  <td class="td-info">
                    <span>
                      <input type="text" id="place" v-model="place" v-bind:disabled=true class="form-control input-place minutes-mode-readonly"  autocomplete="off" placeholder="場所を入力">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="td-icon" style="vertical-align: middle;">
                    <img class="mr-2" src="~@/assets/img/camera.png" width="25" height="25" alt="">
                  </td>
                  <td class="td-label">
                    <label class="pl-2 pr-2 place_url_label">会議URL</label>
                  </td>
                  <td class="td-info">
                    <span>
                      <input type="text" id="meeting_url" v-model="meetingUrl" v-bind:disabled=true class="form-control input-place minutes-mode-readonly" style="width:60%;"  autocomplete="off" placeholder="会議URLを入力">
                    </span>
                  </td>
                </tr>
                <tr class="personarea" >
                  <td class="td-icon">
                    <img class="mr-2" src="~@/assets/img/person.png" width="25" height="25" alt="">
                  </td>   
                  <td class="td-label">
                    <label class="pl-2 pr-2">主催者</label>
                  </td>
                  <td class="td-info">
                    <span class="select-wrap" style="width:15vw;">
                      <select name="user_id" id="organizer" v-model="organizer" v-bind:disabled=true class="user-select form-control editable-select minutes-mode-readonly" autocomplete="off" modallabel="主催者">
                      <option>{{organizer}}</option>
                      </select>
                    </span>
                  </td>
                </tr>
                <tr class="personarea" >
                  <td class="td-icon">
                    <img class="mr-2" src="~@/assets/img/microphone.png" width="25" height="25" alt="">
                  </td>
                  <td class="td-label">
                    <label class="pl-2 pr-2">進行役</label>
                  </td>
                  <td class="td-info">
                    <span class="select-wrap" style="width:15vw;">
                      <select name="user_id" id="facilitator" v-model="facilitator" v-bind:disabled=true class="user-select form-control editable-select minutes-mode-readonly" autocomplete="off" modallabel="進行">
                      <option>{{facilitator}}</option>
                      </select>
                    </span>
                  </td>
                </tr>
                <tr class="personarea" >
                  <td class="td-icon">
                    <img class="mr-2" src="~@/assets/img/pen.png" width="25" height="25" alt="">
                  </td>
                  <td class="td-label">
                    <label class="pl-2 pr-2">議事録</label>
                  </td>
                  <td class="td-info">
                    <span class="select-wrap mr-1" style="width:15vw">
                      <select name="user_id" id="minutes_manager" v-model="minutesManager" v-bind:disabled=true class="user-select form-control editable-select minutes-mode-readonly" autocomplete="off"  modallabel="議事録">
                      <option>{{minutesManager}}</option>
                      </select>
                    </span>
                    <span class="select-wrap mr-1" style="width:15vw">
                      <select name="user_id" id="minutes_manager2" v-model="minutesManager2" v-bind:disabled=true class="user-select form-control editable-select minutes-mode-readonly" autocomplete="off"  modallabel="議事録">
                      <option>{{minutesManager2}}</option>
                      </select>
                    </span>
                    <span class="select-wrap mr-1" style="width:15vw">
                      <select name="user_id" id="minutes_manager3" v-model="minutesManager3" v-bind:disabled=true class="user-select form-control editable-select minutes-mode-readonly" autocomplete="off"  modallabel="議事録">
                      <option>{{minutesManager3}}</option>
                      </select>
                    </span>
                    <span class="select-wrap mr-1" style="width:15vw">
                      <select name="user_id" id="minutes_manager4" v-model="minutesManager4" v-bind:disabled=true class="user-select form-control editable-select minutes-mode-readonly" autocomplete="off"  modallabel="議事録">
                      <option>{{minutesManager4}}</option>
                      </select>
                    </span>
                    <span class="select-wrap mr-1" style="width:15vw">
                      <select name="user_id" id="minutes_manager5" v-model="minutesManager5" v-bind:disabled=true class="user-select form-control editable-select minutes-mode-readonly" autocomplete="off"  modallabel="議事録">
                      <option>{{minutesManager5}}</option>
                      </select>
                    </span>
                  </td>
                </tr>
                <tr class="personarea" >
                  <td class="td-icon">
                    <img class="mr-2" src="~@/assets/img/person.png" width="25" height="25" alt="">
                  </td>
                  <td class="td-label">
                    <label class="pl-2 pr-2">参加者</label>
                  </td>
                  <td class="td-info">
                    <div class="attend_person_area mt-2">
                      <div class="PersonList" id="PersonList"></div>
                    </div>
                    <div class="attend_guest_person_area mt-2">
                      <div class="GuestPersonList" id="GuestPersonList"></div>
                    </div>
                  </td>
                </tr>
                <tr class="tr-item" >
                  <td class="td-icon" style="vertical-align: top;">
                    <img class="mr-2" src="~@/assets/img/graph.png" width="25" height="25" alt="">
                  </td>   
                  <td class="td-label" style="vertical-align: top;">
                    <label class="pl-2 pr-2 place_url_label">予算編成区分</label>
                  </td>
                  <td class="td-info">
                    <div>
                      <label class="mr-3">前月予定</label>
                      <span class="mr-3" id="zengestu_nendo">{{fiscalYearPrePlan}}<template v-if="fiscalYearPrePlan">年度</template></span>
                      <span class="mr-3" id="zengestu_kubun">{{budgetingPrePlan}}</span>
                      <span id="zengestu_tsuki">{{monthPrePlan}}<template v-if="monthPrePlan">月</template></span>
                    </div>
                    <div class="mt-2">
                      <label class="mr-3">前月実績</label>
                      <span class="mr-3" id="jisseki_nendo">{{fiscalYearPreResult}}<template v-if="fiscalYearPreResult">年度</template></span>
                      <span class="mr-3" id="jisseki_kubun">{{budgetingPreResult}}</span>
                      <span id="jisseki_tsuki">{{monthPreResult}}<template v-if="monthPreResult">月</template></span>
                    </div>
                    <div class="mt-2">
                      <label class="mr-3">当月予定</label>
                      <span class="mr-3" id="yotei_nendo">{{fiscalYearPlan}}<template v-if="fiscalYearPlan">年度</template></span>
                      <span class="mr-3" id="yotei_kubun">{{budgetingPlan}}</span>
                      <span id="yotei_tsuki">{{monthPlan}}<template v-if="monthPlan">月</template></span>
                    </div>
                  </td>
               </tr>
              </tbody>
            </table>
          </div>
          </b-collapse>
    	</div>
</template>

<script>

import { nanoid } from 'nanoid'
import $ from "jquery";

export default {
	props: {
		username: String,
		basicData: Object,
	},
	data: () => ({
    agendaId: null,
		agendaName: null,
    committeeID: null,
		committeeName: null,
    minutesHeaderId: null,
		formatName: null,
		meetingDate: null,
		timeFrom: null,
		timeTo: null,
		place: null,
		meetingUrl: null,
		organizer: null,
		facilitator: null,
		minutesManager: null,
		minutesManager2: null,
		minutesManager3: null,
		minutesManager4: null,
		minutesManager5: null,
		fiscalYearPrePlan: null,
		budgetingPrePlan: null,
		monthPrePlan: null,
		fiscalYearPreResult: null,
		budgetingPreResult: null,
		monthPreResult: null,
		fiscalYearPlan: null,
		budgetingPlan: null,
		monthPlan: null,
    minutes_state: null,
    minutes_state_name: null,
	}),
	
	created() {
	},
	
	methods: {
		setBasicInfoData() {
      // アジェンダID
      this.agendaId = this.basicData.agendaDetail["AGENDA_ID"];

			// 会議名
			this.agendaName = this.basicData.agendaDetail["AGENDA_NAME"];
			
      // 会議体ID
      this.committeeID = this.basicData.agendaDetail["COMMITTEE_ID"];

			// 会議体名
			this.committeeName = this.basicData.agendaDetail["COMMITTEE_NAME"];

      // 議事録ヘッダー
      this.minutesHeaderId = this.basicData.agendaDetail["MINUTES_HEADER_ID"];
			
			// フォーマット名
			this.formatName = this.basicData.agendaDetail["FORMAT_NAME"];
			
			// 開催日
			let meetingDate = this.basicData.agendaDetail["MEETING_DATE"];
			this.meetingDate = this.formatDateAtDay(meetingDate);
			
			// 開始時間
			let timeFrom = this.basicData.agendaDetail["TIME_FROM"];
			this.timeFrom = this.formatDateAtMinute(timeFrom, true, true);
			
			// 終了時間
			let timeTo = this.basicData.agendaDetail["TIME_TO"];
			this.timeTo = this.formatDateAtMinute(timeTo, true, true);
			
			// 場所
			this.place = this.basicData.agendaDetail["PLACE"];
			
			// 会議URL
			this.meetingUrl = this.basicData.agendaDetail["MEETING_URL"];
			
			// 主催者
			this.organizer = this.basicData.attend["ORGANIZER_NAME"];
			
			// 進行役
			this.facilitator = this.basicData.attend["FACILITATOR_NAME"];
			
			// 議事録
			this.minutesManager = this.basicData.attend["MINUTES_MANAGER_NAME"];
			this.minutesManager2 = this.basicData.attend["MINUTES_MANAGER2_NAME"];
			this.minutesManager3 = this.basicData.attend["MINUTES_MANAGER3_NAME"];
			this.minutesManager4 = this.basicData.attend["MINUTES_MANAGER4_NAME"];
			this.minutesManager5 = this.basicData.attend["MINUTES_MANAGER5_NAME"];

      // 議事録ステータス
      this.minutes_state = this.basicData.agendaDetail["MINUTES_STATE"];
      this.minutes_state_name = this.basicData.agendaDetail["MINUTES_STATE_NAME"];
			
			// 参加者
			var attendOther = this.basicData.attendOther;
			if (attendOther) {
				var person = '';
				var guestPerson = '';
				for(var i=0; i<attendOther.length; i++) {
					var userid = attendOther[i].USER_ID;
					var username = attendOther[i].USER_NAME;
					if (attendOther[i].USER_CLASS == "01") {
						person = person + '<div class="PersonBlock" user_id="' + this.escapeHTML(userid) +'" user_name="' + this.escapeHTML(username) + '"><i class="bi bi-person-fill"></i><div class="EditableText Person">'+ this.escapeHTML(username) + '</div></div>';
					} else {
						guestPerson = '<div class="GuestPersonBlock" user_id="' + this.escapeHTML(userid) +'" user_name="' + this.escapeHTML(username) + '"><i class="bi bi-person-plus-fill mr-1"></i><div class="EditableText GuestPerson" contentEditable="false">'+ this.escapeHTML(username) + '</div></div>';
						$("#GuestPersonList").append(guestPerson);
					}
				}
				$("#PersonList").append(person);
			}
			
			// 予算編成区分
			this.fiscalYearPrePlan = this.basicData.agendaDetail["FISCAL_YEAR_PRE_PLAN"];
			this.budgetingPrePlan = this.basicData.budget["PREPLAN"];
			this.monthPrePlan = this.basicData.agendaDetail["MONTH_PRE_PLAN"];
			this.fiscalYearPreResult = this.basicData.agendaDetail["FISCAL_YEAR_PRE_RESULT"];
			this.budgetingPreResult = this.basicData.budget["PRERESULT"];
			this.monthPreResult = this.basicData.agendaDetail["MONTH_PRE_RESULT"];
			this.fiscalYearPlan = this.basicData.agendaDetail["FISCAL_YEAR_PLAN"];
			this.budgetingPlan = this.basicData.budget["PLAN"];
			this.monthPlan = this.basicData.agendaDetail["MONTH_PLAN"];
		},
		
		formatDateAtDay(time) {
			var now = new Date(time);
			if(time == null || isNaN(now)) {
				return "";
			}
			return now.getFullYear() + "/" + this.paddingHeadZero(now.getMonth()+1) + "/" + this.paddingHeadZero(now.getDate());
		},
		
		formatDateAtMinute(time, flag, typeTimeFlg) {
			var timeobj;
			if (typeTimeFlg) {
				// 時刻のみの場合
				timeobj = new Date("1900/01/01 " + time);
			} else {
				// 日付型の場合
				timeobj = new Date(time);
			}
			if(time == null || isNaN(timeobj)) {
				return "";
			}
			if(flag) {
				return this.paddingHeadZero(timeobj.getHours()) + ":" + this.paddingHeadZero(timeobj.getMinutes());
			} else {
				return timeobj.getHours() + ":" + this.paddingHeadZero(timeobj.getMinutes());
			}
		},
		
		paddingHeadZero(num) {
			if(num < 10) {
				return "0" + num;
			}
			return num;
		},
		
		escapeHTML(val) {
			if(!isNaN(val)){
				return val;
			} else if(val == null){
				return "";
			} else {
				return val
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, "&#x27;");
			}
		},
    getAgendaId() {
      return this.agendaId;
    },
    getCommitteeID() {
      return this.committeeID;
    },
    getMinutesHeaderId() {
      return this.minutesHeaderId;
    }
	},
	  
	mounted() {
		this.setBasicInfoData();
	},
}
</script>